import { motion } from 'framer-motion';
import React from 'react';
import ReactConfetti from 'react-confetti';
import { useMeasure, useWindowSize } from 'react-use';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { COLORS } from '../../../BeFi20.meta';

export const Confetti = () => {
  const isMobile = useIsMobile();

  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const { height } = useWindowSize();

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
      css="width: 100%;"
    >
      <ReactConfetti
        width={width}
        height={height}
        confettiSource={{
          w: 10,
          h: 10,
          x: width / 2,
          y: height,
        }}
        recycle={false}
        colors={[COLORS.primary]}
        initialVelocityX={isMobile ? 5 : 15}
        initialVelocityY={5}
        tweenDuration={500}
        opacity={0.5}
        numberOfPieces={isMobile ? 500 : 1000}
        gravity={-0.2}
        wind={0}
        friction={0.99}
      />
    </motion.div>
  );
};
